import { SearchModel } from "../../core/core";

export class AuditLogSearchModel extends SearchModel {
  referenceObjectId: string;
  userId: string;
  referenceType: string;
  id: string;
}
